import { AbstractControl } from '@angular/forms';
import { isString } from 'util';
import { List } from 'immutable';

export class EventSearchFilterValidator {

  static PAYMENT_STATUS_ERROR = 'validatePaymentStatus';
  static DATE_ERROR = 'greater';

  static validate(formGroup: AbstractControl): { [key: string]: boolean } | null {
    const payStatus: any = EventSearchFilterValidator.validatePaymentStatus(formGroup);
    const dateCompare: any = EventSearchFilterValidator.dateCompare(formGroup);

    if (payStatus && dateCompare) {
      return Object.assign({}, payStatus, dateCompare);
    } else if (payStatus) {
      return payStatus;
    } else if (dateCompare) {
      return dateCompare;
    } else {
      return null;
    }

  }

  static validatePaymentStatus(formGroup: AbstractControl): { [key: string]: boolean } | null {

    let paymentStatusGroup = formGroup.get('paymentStatus');

    const unpaid = paymentStatusGroup.get('unpaid').value;
    const paid = paymentStatusGroup.get('paid').value;
    const inProcess = paymentStatusGroup.get('inProcess').value;
    const cancelled = paymentStatusGroup.get('cancelled').value;

    const paymentArray: List<{ name: string; value: any }> = List.of(
      {  name: 'unpaid', value: unpaid },
      { name: 'paid', value: paid },
      { name: 'inProcess', value: inProcess },
      { name: 'cancelled', value: cancelled } );

    const isSelected: List<{ name: string; value: any }> = paymentArray.filter(obj => obj.value === true).toList();

    if (isSelected.isEmpty()) {
      paymentStatusGroup.get('paid').markAsTouched();
      let obj = {};
      obj[EventSearchFilterValidator.PAYMENT_STATUS_ERROR] = true;
      return obj;
    }

    return null;
  }

  static dateCompare(formGroup: AbstractControl): { [key: string]: boolean } | null {
    let startDate = formGroup.get('startDate').value;
    let endDate = formGroup.get('endDate').value;

    if (!startDate || !endDate) {
      return null;
    } else {
      // Convert to string if object
      if (!isString(startDate)) {
        startDate = startDate.toUTCString();
      }

      if (!isString(endDate)) {
        endDate = endDate.toUTCString();
      }
    }

    const isInvalid = new Date(startDate) >= new Date(endDate);

    if (isInvalid) {
      formGroup.get('endDate').markAsTouched();

      let obj = {};
      obj[EventSearchFilterValidator.DATE_ERROR] = true;
      return obj;
    }

    return null;
  }
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/event-search-filter/event-search-filter.validator.ts